import { createFileRoute } from "@tanstack/react-router";

import ProxyListPage from "./-components/ProxyListPage";

export const Route = createFileRoute("/_app/_dashboard/$planId/proxy/list/")({
  component: ProxyListPage,
});
